import * as types from "../actions/types";


const initialState = {
    appBarTitle: "",
    language: "fr",
    isDrawerOpen: true,
    AdministrationMenuOpen: false,
    MonitoringMenuOpen: false,
    DeploymentMenuOpen: false,
    DataMenuOpen: false,
    SecurityMenuOpen: false,
    CreationMenuOpen: true,
    OrganisationMenuOpen: false,
    SystemAdministratorMenuOpen: false,
    currentMenuName: ""
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_APPBAR_TITLE:
            return Object.assign({}, state, {
                appBarTitle: action.title
            });
        case types.SET_APP_LANGUAGE:
            return Object.assign({}, state, {
                language: action.language
            });
        case types.CLOSE_DRAWER:
            return Object.assign({}, state, {
                isDrawerOpen: false
            });
        case types.OPEN_DRAWER:
            return Object.assign({}, state, {
                isDrawerOpen: true
            });
        case types.TOGGLE_ADMIN_MENU:
            return Object.assign({}, state, {
                AdministrationMenuOpen: !state.AdministrationMenuOpen
            });
        case types.TOGGLE_DASHBOARD_MENU:
            return Object.assign({}, state, {
                DashboardMenuOpen: !state.DashboardMenuOpen
            });
        case types.TOGGLE_CREATION_MENU:
            return Object.assign({}, state, {
                CreationMenuOpen: !state.CreationMenuOpen
            });
        case types.TOGGLE_DATA_MENU:
            return Object.assign({}, state, {
                DataMenuOpen: !state.DataMenuOpen
            });
        case types.TOGGLE_MONITORING_MENU:
            return Object.assign({}, state, {
                MonitoringMenuOpen: !state.MonitoringMenuOpen
            });
        case types.TOGGLE_DEPLOYMENT_MENU:
            return Object.assign({}, state, {
                DeploymentMenuOpen: !state.DeploymentMenuOpen
            });
        case types.TOGGLE_SECURITY_MENU:
            return Object.assign({}, state, {
                SecurityMenuOpen: !state.SecurityMenuOpen
            });
        case types.TOGGLE_URLCALLS_MENU:
            return Object.assign({}, state, {
                URLCallsMenuOpen: !state.URLCallsMenuOpen
            });
        case types.TOGGLE_CAROUSEL_MENU:
            return Object.assign({}, state, {
                CarouselMenuOpen: !state.CarouselMenuOpen
            });
        case types.TOGGLE_ORGANISATION_MENU:
            return Object.assign({}, state, {
                OrganisationMenuOpen: !state.OrganisationMenuOpen
            });
        case types.TOGGLE_SYS_ADMIN_MENU:
            return Object.assign({}, state, {
                SystemAdministratorMenuOpen: !state.SystemAdministratorMenuOpen
            });
        case types.CLOSE_ALL_MENUS:
            return Object.assign({}, state, {
                DashboardMenuOpen: false,
                AdministrationMenuOpen: false,
                CreationMenuOpen: false,
                DataMenuOpen: false,
                MonitoringMenuOpen: false,
                DeploymentMenuOpen: false,
                SecurityMenuOpen: false,
                URLCallsMenuOpen: false,
                CarouselMenuOpen: false,
                OrganisationMenuOpen: false,
                SystemAdministratorMenuOpen: false
            });
        case types.CHANGE_CURRENT_MENU_NAME:
            return Object.assign({}, state, {
                currentMenuName: action.name
            });
        case types.IS_ACTIVE_MINIFY:
            return Object.assign({}, state, {
                isActiveMinify: !state.isActiveMinify
            });
        default:
            return state;
    }
};
